export default __webpack_public_path__ + "static/media/shopping-bag.4549e902.svg";